module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus/innovation_announcements/hareket3-4d5df6fce3ed4e6d763fc676d65ee58a.jpg";